import React from "react";

const Footprint = React.forwardRef(
  (
    {
      width = "20",
      height = "20",
      viewBox = "0 0 20 20",
      fill = "none",
      fillColor = "white",
      strokeColor = "white",
      className,
      ...props
    },
    ref,
  ) => {
    return (
      <svg
        ref={ref}
        {...{ width, height, viewBox, fill, className }}
        {...props}
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clip-path="url(#clip0_1332_252)">
          <path
            d="M5.76517 2.82136C7.00617 2.08769 8.45391 1.66666 9.99999 1.66666C14.6024 1.66666 18.3333 5.39762 18.3333 9.99999C18.3333 10.0276 18.3332 10.0552 18.3329 10.0827M2.81761 5.77153C2.08626 7.01112 1.66666 8.45655 1.66666 9.99999C1.66666 13.883 4.32243 17.1457 7.91666 18.0708M17.2564 14.1005C16.156 16.0435 14.2978 17.5008 12.0833 18.0708M11.7411 5.31147C11.1989 5.11005 10.6123 4.99999 9.99999 4.99999C7.23857 4.99999 4.99999 7.23857 4.99999 9.99999C4.99999 10.6156 5.11125 11.2053 5.31476 11.7499M14.6876 8.25638C14.8896 8.79927 15 9.38674 15 9.99999C15 12.7614 12.7614 15 9.99999 15C9.39177 15 8.80892 14.8914 8.26977 14.6925M9.99999 8.33332V11.6667"
            stroke={strokeColor}
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
        <defs>
          <clipPath id="clip0_1332_252">
            <rect width="20" height="20" fill={fillColor} />
          </clipPath>
        </defs>
      </svg>
    );
  },
);

export default Footprint;
